import Skelet from '../Skelet';
import css from '../../styles/modules/buildings/BuildingsCatalogItem.module.scss';

const BuildingsCatalogSkeletonItem = () => {
  /** TEMPLATE */
  return (
    <div className={css.item}>
      <div className={css.itemBuilding}>
        <Skelet className={css.itemBuildingTitle} height={33} width={200} />
        <Skelet className={css.itemBuildingSubtitle} height={21} width={300} />
        <Skelet className={css.itemBuildingDescription} height={100} />
        <div className={css.itemBuildingPreview}>
          <Skelet style={{ borderRadius: 19, height: 200 }} />
        </div>
      </div>
      <div className={css.itemContent}>
        <div className={css.itemLabels}>
          <Skelet
            className={css.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
          <Skelet
            className={css.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
          <Skelet
            className={css.itemLabel}
            width={80}
            height={80}
            style={{ borderRadius: '50%' }}
          />
        </div>
        <div className={css.itemVariants}>
          <Skelet
            className={css.itemVariant}
            style={{ width: 'calc(100% - 32px)', height: '80px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default BuildingsCatalogSkeletonItem;
